import activityReducer from './activity-slice';
import courseReducer from './course-slice';
import adminGroupReducer from './admin-group-slice';
import loginReducer from './login-slice';
import navReducer from './nav-slice';
import modalReducer from './modal-slice';
import lessonFlowReducer from './lesson-flow-slice';
import quizReducer from './quiz-slice';
import quizUiReducer from './quiz-ui-slice';
import signupReducer from './signup-slice';
import subunitReducer from './subunit-slice';
import unitReducer from './unit-slice';
import insightsReducer from './insights-slice';
import graderReducer from './grader-slice';
import routeGuardReducer from './route-guard-slice';
import studyReducer from './study-slice';
import profileReducer from './profile-slice';

export {
  activityReducer,
  courseReducer,
  adminGroupReducer,
  loginReducer,
  navReducer,
  modalReducer,
  lessonFlowReducer,
  quizReducer,
  quizUiReducer,
  signupReducer,
  subunitReducer,
  unitReducer,
  insightsReducer,
  graderReducer,
  routeGuardReducer,
  studyReducer,
  profileReducer,
};
